import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { routes } from './config/routes';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { ErrorBoundary } from './components/common/ErrorBoundary';

// Pages
















// Phase 2 - Bills & Purchase Orders







// Phase 2 - Payments




// Phase 2 - Banking




// Phase 2 - Reports


















// Phase 3 - Bank Feeds





// Phase 3 - Documents


// Phase 3 - Recurring Invoices



// Phase 3 - Integrations




// Phase 3 - Automation Settings


// Phase 4 - Payroll
import {
  EmployeesPage,
  EmployeeForm,
  EmployeeDetail,
  PayRunsPage,
  PayRunForm,
  PayRunDetail,
  PayRunItemForm,
  PayslipViewer,
  STPSubmissionsPage,
  STPSubmissionDetail,
  SuperFundsPage,
  SuperContributionsPage,
  LeavePage,
  LeaveApplicationForm,
  LeaveApprovalPage,
  TimesheetsPage,
  TimesheetCalendar,
  ABAFilesPage,
} from './pages/Payroll';

// CRM / Sales









// Stock / Inventory








// Production



// Shipping



// FX



// Assets




// Projects




// Files


// Settings (new)





// Route-level code splitting — pages load on demand
const Login = lazy(() => import('./pages/Login').then(m => ({ default: m.Login })));
const Register = lazy(() => import('./pages/Register').then(m => ({ default: m.Register })));
const SupplierPortalPage = lazy(() => import('./pages/Portal/SupplierPortalPage').then(m => ({ default: m.SupplierPortalPage })));
const ChatPage = lazy(() => import('./pages/Chat/ChatPage').then(m => ({ default: m.ChatPage })));
const CalendarPage = lazy(() => import('./pages/Calendar/CalendarPage').then(m => ({ default: m.CalendarPage })));
const MeetingsPage = lazy(() => import('./pages/Meetings/MeetingsPage').then(m => ({ default: m.MeetingsPage })));
const EmailPage = lazy(() => import('./pages/Email/EmailPage').then(m => ({ default: m.EmailPage })));
const EmailCallbackPage = lazy(() => import('./pages/Email/EmailCallbackPage').then(m => ({ default: m.EmailCallbackPage })));
const Dashboard = lazy(() => import('./pages/Dashboard').then(m => ({ default: m.Dashboard })));
const ContactsList = lazy(() => import('./pages/Contacts/ContactsList').then(m => ({ default: m.ContactsList })));
const ContactForm = lazy(() => import('./pages/Contacts/ContactForm').then(m => ({ default: m.ContactForm })));
const ContactMapPage = lazy(() => import('./pages/Contacts/ContactMapPage').then(m => ({ default: m.ContactMapPage })));
const InvoicesList = lazy(() => import('./pages/Invoices/InvoicesList').then(m => ({ default: m.InvoicesList })));
const InvoiceForm = lazy(() => import('./pages/Invoices/InvoiceForm').then(m => ({ default: m.InvoiceForm })));
const Settings = lazy(() => import('./pages/Settings').then(m => ({ default: m.Settings })));
const BillsList = lazy(() => import('./pages/Bills/BillsList').then(m => ({ default: m.BillsList })));
const BillForm = lazy(() => import('./pages/Bills/BillForm').then(m => ({ default: m.BillForm })));
const BillDetail = lazy(() => import('./pages/Bills/BillDetail').then(m => ({ default: m.BillDetail })));
const PurchaseOrdersList = lazy(() => import('./pages/PurchaseOrders/PurchaseOrdersList').then(m => ({ default: m.PurchaseOrdersList })));
const PurchaseOrderForm = lazy(() => import('./pages/PurchaseOrders/PurchaseOrderForm').then(m => ({ default: m.PurchaseOrderForm })));
const PurchaseOrderDetail = lazy(() => import('./pages/PurchaseOrders/PurchaseOrderDetail').then(m => ({ default: m.PurchaseOrderDetail })));
const PaymentsList = lazy(() => import('./pages/Payments/PaymentsList').then(m => ({ default: m.PaymentsList })));
const PaymentForm = lazy(() => import('./pages/Payments/PaymentForm').then(m => ({ default: m.PaymentForm })));
const PaymentDetail = lazy(() => import('./pages/Payments/PaymentDetail').then(m => ({ default: m.PaymentDetail })));
const BankAccountsList = lazy(() => import('./pages/Banking/BankAccountsList').then(m => ({ default: m.BankAccountsList })));
const BankTransactions = lazy(() => import('./pages/Banking/BankTransactions').then(m => ({ default: m.BankTransactions })));
const ReconciliationPage = lazy(() => import('./pages/Banking/ReconciliationPage').then(m => ({ default: m.ReconciliationPage })));
const ReportsDashboard = lazy(() => import('./pages/Reports/ReportsDashboard').then(m => ({ default: m.ReportsDashboard })));
const ProfitLossPage = lazy(() => import('./pages/Reports/ProfitLossPage').then(m => ({ default: m.ProfitLossPage })));
const BalanceSheetPage = lazy(() => import('./pages/Reports/BalanceSheetPage').then(m => ({ default: m.BalanceSheetPage })));
const GSTPage = lazy(() => import('./pages/Reports/GSTPage').then(m => ({ default: m.GSTPage })));
const ChartOfAccounts = lazy(() => import('./pages/Reports/ChartOfAccounts').then(m => ({ default: m.ChartOfAccounts })));
const TrialBalancePage = lazy(() => import('./pages/Reports/TrialBalancePage').then(m => ({ default: m.TrialBalancePage })));
const JournalsPage = lazy(() => import('./pages/Reports/JournalsPage').then(m => ({ default: m.JournalsPage })));
const BudgetsPage = lazy(() => import('./pages/Reports/BudgetsPage').then(m => ({ default: m.BudgetsPage })));
const AccountTransactionsPage = lazy(() => import('./pages/Reports/AccountTransactionsPage').then(m => ({ default: m.AccountTransactionsPage })));
const GSTDetailPage = lazy(() => import('./pages/Reports/GSTDetailPage').then(m => ({ default: m.GSTDetailPage })));
const SalesSummaryPage = lazy(() => import('./pages/Reports/SalesPurchasesSummaryPage').then(m => ({ default: m.SalesSummaryPage })));
const PurchasesSummaryPage = lazy(() => import('./pages/Reports/SalesPurchasesSummaryPage').then(m => ({ default: m.PurchasesSummaryPage })));
const InventoryValuationPage = lazy(() => import('./pages/Reports/InventoryValuationPage').then(m => ({ default: m.InventoryValuationPage })));
const RecurringPage = lazy(() => import('./pages/Purchases/RecurringPage').then(m => ({ default: m.RecurringPage })));
const CreditNotesPage = lazy(() => import('./pages/Sales/CreditNotesPage').then(m => ({ default: m.CreditNotesPage })));
const ExpenseClaimsPage = lazy(() => import('./pages/Payroll/ExpenseClaimsPage').then(m => ({ default: m.ExpenseClaimsPage })));
const PayrollReportsPage = lazy(() => import('./pages/Payroll/PayrollReportsPage').then(m => ({ default: m.PayrollReportsPage })));
const ImportExportPage = lazy(() => import('./pages/Settings/ImportExportPage').then(m => ({ default: m.ImportExportPage })));
const BankFeedsPage = lazy(() => import('./pages/Banking/BankFeedsPage').then(m => ({ default: m.BankFeedsPage })));
const ConnectBankPage = lazy(() => import('./pages/Banking/ConnectBankPage').then(m => ({ default: m.ConnectBankPage })));
const BankRulesPage = lazy(() => import('./pages/Banking/BankRulesPage').then(m => ({ default: m.BankRulesPage })));
const BankRuleForm = lazy(() => import('./pages/Banking/BankRuleForm').then(m => ({ default: m.BankRuleForm })));
const DocumentsPage = lazy(() => import('./pages/Documents/DocumentsPage').then(m => ({ default: m.DocumentsPage })));
const RecurringInvoicesPage = lazy(() => import('./pages/RecurringInvoices/RecurringInvoicesPage').then(m => ({ default: m.RecurringInvoicesPage })));
const RecurringInvoiceForm = lazy(() => import('./pages/RecurringInvoices/RecurringInvoiceForm').then(m => ({ default: m.RecurringInvoiceForm })));
const IntegrationsDashboard = lazy(() => import('./pages/Integrations/IntegrationsDashboard').then(m => ({ default: m.IntegrationsDashboard })));
const ConnectShoplinePage = lazy(() => import('./pages/Integrations/ConnectShoplinePage').then(m => ({ default: m.ConnectShoplinePage })));
const SyncStatusPage = lazy(() => import('./pages/Integrations/SyncStatusPage').then(m => ({ default: m.SyncStatusPage })));
const AutomationSettings = lazy(() => import('./pages/Settings/AutomationSettings').then(m => ({ default: m.AutomationSettings })));
const LeadsPage = lazy(() => import('./pages/Sales/Leads').then(m => ({ default: m.LeadsPage })));
const CustomerPriceLists = lazy(() => import('./pages/Sales/CustomerPriceLists').then(m => ({ default: m.CustomerPriceLists })));
const QuotesList = lazy(() => import('./pages/Quotes/QuotesList').then(m => ({ default: m.QuotesList })));
const QuoteForm = lazy(() => import('./pages/Quotes/QuoteForm').then(m => ({ default: m.QuoteForm })));
const QuoteDetail = lazy(() => import('./pages/Quotes/QuoteDetail').then(m => ({ default: m.QuoteDetail })));
const SalesOrdersList = lazy(() => import('./pages/SalesOrders/SalesOrdersList').then(m => ({ default: m.SalesOrdersList })));
const SalesOrderForm = lazy(() => import('./pages/SalesOrders/SalesOrderForm').then(m => ({ default: m.SalesOrderForm })));
const SalesOrderDetail = lazy(() => import('./pages/SalesOrders/SalesOrderDetail').then(m => ({ default: m.SalesOrderDetail })));
const ProductCatalogue = lazy(() => import('./pages/Stock/ProductCatalogue').then(m => ({ default: m.ProductCatalogue })));
const ProductForm = lazy(() => import('./pages/Stock/ProductForm').then(m => ({ default: m.ProductForm })));
const ProductDetail = lazy(() => import('./pages/Stock/ProductDetail').then(m => ({ default: m.ProductDetail })));
const StockLevels = lazy(() => import('./pages/Stock/StockLevels').then(m => ({ default: m.StockLevels })));
const WarehousesPage = lazy(() => import('./pages/Stock/Warehouses').then(m => ({ default: m.WarehousesPage })));
const StockMovementsPage = lazy(() => import('./pages/Stock/StockMovements').then(m => ({ default: m.StockMovementsPage })));
const PriceHistoryPage = lazy(() => import('./pages/Stock/PriceHistoryPage').then(m => ({ default: m.PriceHistoryPage })));
const BOMPage = lazy(() => import('./pages/Production/BOMPage').then(m => ({ default: m.BOMPage })));
const ProductionScheduling = lazy(() => import('./pages/Production/ProductionScheduling').then(m => ({ default: m.ProductionScheduling })));
const ShipmentsPage = lazy(() => import('./pages/Shipping/ShipmentsPage').then(m => ({ default: m.ShipmentsPage })));
const ContainerTrackingPage = lazy(() => import('./pages/Shipping/ContainerTrackingPage').then(m => ({ default: m.ContainerTrackingPage })));
const FXBeneficiaries = lazy(() => import('./pages/FX/FXBeneficiaries').then(m => ({ default: m.FXBeneficiaries })));
const FXTransfers = lazy(() => import('./pages/FX/FXTransfers').then(m => ({ default: m.FXTransfers })));
const AssetManagement = lazy(() => import('./pages/Assets/AssetManagement').then(m => ({ default: m.AssetManagement })));
const AssetUsageTracking = lazy(() => import('./pages/Assets/AssetUsageTracking').then(m => ({ default: m.AssetUsageTracking })));
const AssetMaintenancePage = lazy(() => import('./pages/Assets/AssetMaintenancePage').then(m => ({ default: m.AssetMaintenancePage })));
const ProjectsPage = lazy(() => import('./pages/Projects/ProjectsPage').then(m => ({ default: m.ProjectsPage })));
const ProjectDetail = lazy(() => import('./pages/Projects/ProjectDetail').then(m => ({ default: m.ProjectDetail })));
const TimeTracking = lazy(() => import('./pages/Projects/TimeTracking').then(m => ({ default: m.TimeTracking })));
const CloudStorage = lazy(() => import('./pages/Files/CloudStorage').then(m => ({ default: m.CloudStorage })));
const DocumentTemplates = lazy(() => import('./pages/Settings/DocumentTemplates').then(m => ({ default: m.DocumentTemplates })));
const ActivityLogPage = lazy(() => import('./pages/Settings/ActivityLogPage').then(m => ({ default: m.ActivityLogPage })));
const CompanyBranding = lazy(() => import('./pages/Settings/CompanyBranding').then(m => ({ default: m.CompanyBranding })));

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<div className="flex h-screen items-center justify-center text-muted-foreground">Loading...</div>}>
      <Routes>
        {/* Public Routes */}
        <Route path={routes.login} element={<Login />} />
        <Route path={routes.register} element={<Register />} />
        <Route path={routes.supplierPortal} element={<SupplierPortalPage />} />
        
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path={routes.dashboard} element={<Dashboard />} />
            <Route path={routes.chat} element={<ChatPage />} />
            <Route path={routes.calendar} element={<CalendarPage />} />
            <Route path={routes.meetings} element={<MeetingsPage />} />
            <Route path={routes.email} element={<EmailPage />} />
            <Route path={routes.emailCallback} element={<EmailCallbackPage />} />
            
            {/* Contacts Routes */}
            <Route path={routes.contacts} element={<ContactsList />} />
            <Route path={routes.contactsNew} element={<ContactForm />} />
            <Route path={routes.contactMap} element={<ContactMapPage />} />
            <Route path={routes.contactDetail} element={<ContactForm />} />
            
            {/* Invoices Routes */}
            <Route path={routes.invoices} element={<InvoicesList />} />
            <Route path={routes.invoicesNew} element={<InvoiceForm />} />
            <Route path={routes.invoiceDetail} element={<InvoiceForm />} />
            
            {/* Bills Routes */}
            <Route path={routes.bills} element={<BillsList />} />
            <Route path={routes.recurringTransactions} element={<RecurringPage />} />
            <Route path={routes.billsNew} element={<BillForm />} />
            <Route path={routes.billDetail} element={<BillDetail />} />
            
            {/* Purchase Orders Routes */}
            <Route path={routes.purchaseOrders} element={<PurchaseOrdersList />} />
            <Route path={routes.purchaseOrdersNew} element={<PurchaseOrderForm />} />
            <Route path={routes.purchaseOrderDetail} element={<PurchaseOrderDetail />} />
            
            {/* Payments Routes */}
            <Route path={routes.payments} element={<PaymentsList />} />
            <Route path={routes.paymentsNew} element={<PaymentForm />} />
            <Route path={routes.paymentDetail} element={<PaymentDetail />} />
            
            {/* Banking Routes */}
            <Route path={routes.bankAccounts} element={<BankAccountsList />} />
            <Route path={routes.bankTransactions} element={<BankTransactions />} />
            <Route path={routes.reconciliation} element={<ReconciliationPage />} />
            
            {/* Phase 3 - Bank Feeds & Rules */}
            <Route path={routes.bankFeeds} element={<BankFeedsPage />} />
            <Route path={routes.connectBank} element={<ConnectBankPage />} />
            <Route path={routes.bankRules} element={<BankRulesPage />} />
            <Route path={routes.bankRulesNew} element={<BankRuleForm />} />
            <Route path={routes.bankRuleDetail} element={<BankRuleForm />} />
            
            {/* Phase 3 - Documents */}
            <Route path={routes.documents} element={<DocumentsPage />} />
            
            {/* Phase 3 - Recurring Invoices */}
            <Route path={routes.recurringInvoices} element={<RecurringInvoicesPage />} />
            <Route path={routes.recurringInvoicesNew} element={<RecurringInvoiceForm />} />
            <Route path={routes.recurringInvoiceDetail} element={<RecurringInvoiceForm />} />
            
            {/* Phase 3 - Integrations */}
            <Route path={routes.integrations} element={<IntegrationsDashboard />} />
            <Route path={routes.connectShopline} element={<ConnectShoplinePage />} />
            <Route path={routes.integrationSyncStatus} element={<SyncStatusPage />} />
            
            {/* Reports Routes */}
            <Route path={routes.reports} element={<ReportsDashboard />} />
            <Route path={routes.profitLoss} element={<ProfitLossPage />} />
            <Route path={routes.balanceSheet} element={<BalanceSheetPage />} />
            <Route path={routes.gstReport} element={<GSTPage />} />
            <Route path={routes.chartOfAccounts} element={<ChartOfAccounts />} />
            <Route path={routes.trialBalance} element={<TrialBalancePage />} />
            <Route path={routes.journals} element={<JournalsPage />} />
            <Route path={routes.budgets} element={<BudgetsPage />} />
            <Route path={routes.accountTransactions} element={<AccountTransactionsPage />} />
            <Route path={routes.gstDetail} element={<GSTDetailPage />} />
            <Route path={routes.salesSummary} element={<SalesSummaryPage />} />
            <Route path={routes.purchasesSummary} element={<PurchasesSummaryPage />} />
            <Route path={routes.inventoryValuation} element={<InventoryValuationPage />} />
            <Route path={routes.creditNotes} element={<CreditNotesPage />} />
            <Route path={routes.expenseClaims} element={<ExpenseClaimsPage />} />
            <Route path={routes.payrollReports} element={<PayrollReportsPage />} />
            
            {/* Settings Routes */}
            <Route path={routes.settings} element={<Settings />} />
            <Route path={routes.automationSettings} element={<AutomationSettings />} />
            <Route path={routes.importExport} element={<ImportExportPage />} />
            
            {/* Phase 4 - Payroll Routes */}
            {/* Employees */}
            <Route path={routes.employees} element={<EmployeesPage />} />
            <Route path={routes.employeesNew} element={<EmployeeForm />} />
            <Route path={routes.employeeDetail} element={<EmployeeDetail />} />
            
            {/* Pay Runs */}
            <Route path={routes.payRuns} element={<PayRunsPage />} />
            <Route path={routes.payRunsNew} element={<PayRunForm />} />
            <Route path={routes.payRunDetail} element={<PayRunDetail />} />
            <Route path={routes.payRunItem} element={<PayRunItemForm />} />
            
            {/* Payslips */}
            <Route path={routes.payslipViewer} element={<PayslipViewer />} />
            
            {/* STP */}
            <Route path={routes.stpSubmissions} element={<STPSubmissionsPage />} />
            <Route path={routes.stpSubmissionDetail} element={<STPSubmissionDetail />} />
            
            {/* Superannuation */}
            <Route path={routes.superFunds} element={<SuperFundsPage />} />
            <Route path={routes.superContributions} element={<SuperContributionsPage />} />
            
            {/* Leave */}
            <Route path={routes.leave} element={<LeavePage />} />
            <Route path={routes.leaveApply} element={<LeaveApplicationForm />} />
            <Route path={routes.leaveApprovals} element={<LeaveApprovalPage />} />
            
            {/* Timesheets */}
            <Route path={routes.timesheets} element={<TimesheetsPage />} />
            <Route path={routes.timesheetCalendar} element={<TimesheetCalendar />} />
            
            {/* ABA Files */}
            <Route path={routes.abaFiles} element={<ABAFilesPage />} />

            {/* CRM / Sales */}
            <Route path={routes.leads} element={<LeadsPage />} />
            <Route path={routes.customerPriceLists} element={<CustomerPriceLists />} />
            <Route path={routes.quotes} element={<QuotesList />} />
            <Route path={routes.quotesNew} element={<QuoteForm />} />
            <Route path={routes.quoteDetail} element={<QuoteDetail />} />
            <Route path={routes.quoteEdit} element={<QuoteForm />} />
            <Route path={routes.salesOrders} element={<SalesOrdersList />} />
            <Route path={routes.salesOrdersNew} element={<SalesOrderForm />} />
            <Route path={routes.salesOrderDetail} element={<SalesOrderDetail />} />
            <Route path={routes.salesOrderEdit} element={<SalesOrderForm />} />

            {/* Stock / Inventory */}
            <Route path={routes.products} element={<ProductCatalogue />} />
            <Route path={routes.productsNew} element={<ProductForm />} />
            <Route path={routes.productDetail} element={<ProductDetail />} />
            <Route path={routes.productEdit} element={<ProductForm />} />
            <Route path={routes.stockLevels} element={<StockLevels />} />
            <Route path={routes.warehouses} element={<WarehousesPage />} />
            <Route path={routes.stockMovements} element={<StockMovementsPage />} />
            <Route path={routes.priceHistory} element={<PriceHistoryPage />} />

            {/* Production */}
            <Route path={routes.bom} element={<BOMPage />} />
            <Route path={routes.production} element={<ProductionScheduling />} />

            {/* Shipping */}
            <Route path={routes.shipments} element={<ShipmentsPage />} />
            <Route path={routes.containerTracking} element={<ContainerTrackingPage />} />

            {/* FX */}
            <Route path={routes.fxBeneficiaries} element={<FXBeneficiaries />} />
            <Route path={routes.fxTransfers} element={<FXTransfers />} />
            <Route path={routes.fxDashboard} element={<FXTransfers />} />

            {/* Assets */}
            <Route path={routes.assets} element={<AssetManagement />} />
            <Route path={routes.assetUsage} element={<AssetUsageTracking />} />
            <Route path={routes.assetMaintenance} element={<AssetMaintenancePage />} />

            {/* Projects */}
            <Route path={routes.projects} element={<ProjectsPage />} />
            <Route path={routes.projectDetail} element={<ProjectDetail />} />
            <Route path={routes.timeTracking} element={<TimeTracking />} />

            {/* Files */}
            <Route path={routes.files} element={<CloudStorage />} />

            {/* Settings (new) */}
            <Route path={routes.documentTemplates} element={<DocumentTemplates />} />
            <Route path={routes.activityLog} element={<ActivityLogPage />} />
            <Route path={routes.companyBranding} element={<CompanyBranding />} />
          </Route>
        </Route>
        
        {/* Redirect root to dashboard or login */}
        <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        
        {/* 404 - Redirect to dashboard */}
        <Route path="*" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
